<template>
  <div class="mobile-control-component">
    <PhoneInput
      :value="phoneNumber"
      @input="updatePhoneInput"
      @update:dialCode="handleDialCode"
      class="input-phone"
      type="text"
      :style="{ color: $store.registratorCaptionColor }"
    />
    <div class="numbers">
      <button
        v-for="number in numbers"
        :key="number.label"
        class="button-number"
        :style="{ borderColor: $store.registratorCaptionColor, opacity: number.opacity }"
        @click="number.action()"
      >
        {{ number.label ? number.label : '' }}
        <template v-if="number.icon">
          <i :class="number.icon" />
        </template>
      </button>
    </div>
  </div>
</template>

<script>
import PhoneInput from './phone-input/PhoneInput';

export default {
  name: 'MobilePhoneControl',
  components: {
    PhoneInput,
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      phoneNumber: this.value,
      dialCode: '',
      numbers: [
        {
          label: '1',
          action: this.printNumber.bind(this, '1')
        },
        {
          label: '2',
          action: this.printNumber.bind(this, '2')
        },
        {
          label: '3',
          action: this.printNumber.bind(this, '3')
        },
        {
          label: '4',
          action: this.printNumber.bind(this, '4')
        },
        {
          label: '5',
          action: this.printNumber.bind(this, '5')
        },
        {
          label: '6',
          action: this.printNumber.bind(this, '6')
        },
        {
          label: '7',
          action: this.printNumber.bind(this, '7')
        },
        {
          label: '8',
          action: this.printNumber.bind(this, '8')
        },
        {
          label: '9',
          action: this.printNumber.bind(this, '9')
        },
        {
          label: 'h',
          action: () => {},
          opacity: 0
        },
        {
          label: '0',
          action: this.printNumber.bind(this, '0')
        },
        {
          icon: 'ri-arrow-left-s-line',
          action: this.clearLastNumber.bind(this)
        },
      ]
    }
  },
  watch: {
    phoneNumber: {
      handler(newValue) {
        this.$emit('input', newValue);
      },
      immediate: true
    },
    value(newValue) {
      if (newValue !== this.phoneNumber) {
        this.phoneNumber = newValue;
      }
    }
  },
  methods: {
    updatePhoneInput(value) {
      this.phoneNumber = value;
    },
    handleDialCode(dialCode) {
      this.dialCode = dialCode;
      this.$emit("update:countryDialCode", this.dialCode);
    },
    printNumber(number) {
      if(this.phoneNumber.startsWith('7') || this.phoneNumber.startsWith('48')) {
        if (this.phoneNumber.length > 10) return;
      }
      if(this.phoneNumber.startsWith('375')) {
        if (this.phoneNumber.length > 11) return;
      }
      if (this.phoneNumber.length < 13) this.phoneNumber += number;
    },
    clearLastNumber() {
      this.phoneNumber = this.phoneNumber.slice(0, -1);
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-control-component {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.button-number,
.input-phone {
  font-feature-settings: normal;
}

.numbers {
  width: 304px;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 32px;
  margin-top: min(48px, 4.6875vh);

  .button-number {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border: none;
    background: #FFFFFF;
    box-shadow: 0px 33px 38px rgba(0, 0, 0, 0.0314074), 0px 12px 12px rgba(0, 0, 0, 0.05), 0px 3px 3px rgba(0, 0, 0, 0.08);
    font-size: 64px;
    font-weight: 400;

    i {
      font-size: 56px;
      margin-right: 0;
    }
  }
}

.input-phone {
  padding: 18px 0 18px 23px;
  font-size: 64px;
  background: rgba(239, 239, 244, 0.3);
  border-radius: 20px;
  min-width: 640px;
  height: auto;
  border: none;
  pointer-events: none;
}
</style>
